import { useState } from 'react';
import './TruncatedValue.css';

export interface TruncatedValueProps {
  /** Full value (shown on hover / in tooltip) */
  value: string;
  /** Short display value. If not provided, uses `value` as-is. */
  short?: string;
  /** Copy to clipboard on click (default: true) */
  copyable?: boolean;
  className?: string;
}

/**
 * Displays a truncated value with full value on hover.
 * Optionally copies full value to clipboard on click.
 */
export function TruncatedValue({ value, short, copyable = true, className }: TruncatedValueProps) {
  const [toast, setToast] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    if (!copyable) return;
    e.stopPropagation();
    navigator.clipboard.writeText(value).then(() => {
      setToast(true);
      setTimeout(() => setToast(false), 1200);
    }).catch(() => {});
  };

  return (
    <span
      className={`truncated-value ${copyable ? 'copyable' : ''} ${className || ''}`}
      title={value}
      onClick={handleClick}
    >
      {short || value}
      {toast && <span className="truncated-value-toast">Copied</span>}
    </span>
  );
}
